module.exports = __webpack_public_path__ + "static/img/menu-xs.e93cdc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-xs.png
// module id = pfbU
// module chunks = 2